import styled, {keyframes, css} from 'styled-components';
import {basicColor} from '@/styles/template';


export const LeftWrap = styled.div`
  display: flex;
  align-items: center;
  
    ${({ imgStyle }) => imgStyle && css`
        position: absolute;
        left: 3rem;
        top: 3rem;
        z-index: 1;
    `}
`;

export const Hidden = styled.input.attrs({ type: 'radio' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`

const DashAnimation =  keyframes`
    to {
      stroke-dashoffset: 0;
    }
`

export const CircleSVG = styled.svg`
    position: absolute;
    width: 7rem;
    height: 7rem;
    top: -2rem;
    left: -2rem;
    pointer-events: none;

  & path {
        stroke-dasharray: 300;
        stroke-dashoffset: 300;
        stroke: ${({ wrongAnswer, rightAnswer }) => wrongAnswer ? basicColor.red : rightAnswer ? basicColor.secondary : basicColor.accent};
        stroke-width: 5px;
        stroke-linecap: round;
        stroke-linejoin: round;
        fill: none;
         animation: ${DashAnimation} 0.2s linear forwards;
    }
`

export const StyledRadio = styled.div`
    position: relative;
    display: inline-flex;
    justify-self: center;
    align-items: center;
    min-width: 3rem;
    height: 3rem;
    border-radius: 100%;
    transition: all 150ms;
    background: ${basicColor.white};
  
    ${({ isSelected }) => isSelected && css`
        background: ${basicColor.white};
    `}
`;

